<template>
    <div class="sightseeing">
        <div class="sightseeing-center" ref="sightseeing">
            <div class="top">
                <div class="left" :class="{'animateX':isAnimate}">
                    <img loading="lazy"  :src="sightseeingInfo.img1" alt="">
                    <div class="left-content">
                        <div class="title">{{sightseeingInfo.title}}</div>
                        <div class="desc">{{sightseeingInfo.desc}}</div>
                    </div>
                </div>
                <img :class="{'animateRight':isAnimate}" loading="lazy"  :src="sightseeingInfo.img2" alt="">
            </div>
            <div class="bottom">
                <img loading="lazy" :class="{'animateX':isAnimate}"  :src="sightseeingInfo.img3" alt="">
                <img v-show="viewportWidthNum > 799" loading="lazy" :class="{'banner-fade-in':isAnimate}"  :src="sightseeingInfo.img4" alt="">
                <img loading="lazy" :class="{'animateRight':isAnimate}"  :src="sightseeingInfo.img5" alt="">
            </div>
            <img class="bottom-img" v-show="viewportWidthNum <= 799" loading="lazy" :class="{'banner-fade-in':isAnimate}"  :src="sightseeingInfo.img4" alt="">
        </div>
    </div>
</template>
<script>
export default {
    props: {
        sightseeingInfo: Object,
        viewportWidth: String
    },
    data(){
        return {
            isAnimate:false,
            viewportWidthNum:0,
        }
    },
    watch:{
        viewportWidth:{
            handler(newVal){
                this.viewportWidthNum = newVal;
            },
            immediate:true,
            deep:true
        }
    },
    mounted() {
         const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                // 当 .Popular-products 进入视口时触发动画
                if (entry.isIntersecting) {
                    this.isAnimate = true;
                    observer.unobserve(entry.target); // 只触发一次
                }
            });
        }, { threshold: 0.1 }); // 触发时，至少 10% 的元素进入视口

        // 开始观察
        observer.observe(this.$refs.sightseeing);
    },
}
</script>
<style scoped lang="scss">
@import '/style/pc/common/fadeIn.scss';
@import '/style/pc/common/animateX.scss';
@import '/style/pc/common/animateRight.scss';
@import '/style/phone/experience/montageImg/montageImg.scss';
     .sightseeing{
        .sightseeing-center{
            padding: 5.625rem 0;
            width: 75rem;
            margin: 0 auto;
            .top{
                display: flex;
                justify-content: space-between;
                margin-bottom: 1.875rem;
                img{
                    display: block;
                    width: 36.25rem;
                    height: 16rem;
                }
                .left{
                    position: relative;
                    .left-content{
                        position: absolute;
                        left: 2.5rem;
                        bottom: 50%;
                        transform: translateY(50%);
                        text-align: left;
                        .title{
                            color: #FFF;
                            font-size: 2rem;
                            font-style: normal;
                            font-weight: 500;
                            line-height: 150%;
                            width: 13.8125rem;
                            font-family: Butler;
                            margin-bottom: 2.5rem;
                        }
                        .desc{
                            width: 31.875rem;
                            color: #FFF;
                            font-size: 1rem;
                            font-weight: 300;
                            line-height: 150%;
                            letter-spacing: 0.06rem;
                            font-family: Inter;
                        }
                    }
                }
            }
            .bottom{
                display: flex;
                justify-content: space-between;
                height: 16rem;
                img{
                    display: block;
                    height: 100%;
                }
                img:nth-child(1){
                    width: 17.25rem;
                }
                img:nth-child(2){
                    width: 30.25rem;
                }
                img:nth-child(3){
                    width: 23.75rem;
                }
            }
        }
    }
</style>